// AB   ZIP-005
// Homepage Benefits Marquee - Touch Interaction Handler
// Pauses animation on user interaction, allows manual scrolling, resumes from position after interaction ends

(function() {
  'use strict';

  if (window.innerWidth > 750) return; // Mobile only

  document.addEventListener('DOMContentLoaded', function() {
    const benefitsContainer = document.querySelector('.homepage-benefits-marquee__container');
    if (!benefitsContainer) return;

    const track = benefitsContainer.querySelector('.homepage-benefits-marquee__track--mobile');
    if (!track) return;

    let isInteracting = false;
    let resumeTimeout = null;

    // Pause animation and enable scrolling
    function pauseAnimation() {
      if (!isInteracting) {
        isInteracting = true;
        track.classList.add('is-paused');
      }
    }

    // Resume animation after interaction ends
    function resumeAnimation() {
      if (resumeTimeout) {
        clearTimeout(resumeTimeout);
      }
      
      resumeTimeout = setTimeout(function() {
        // Reset scroll position to beginning before resuming animation
        benefitsContainer.scrollLeft = 0;
        
        // Small delay to ensure scroll position is reset before removing pause
        requestAnimationFrame(function() {
          isInteracting = false;
          track.classList.remove('is-paused');
        });
      }, 500); // Resume after 500ms of no interaction
    }

    // Touch events
    benefitsContainer.addEventListener('touchstart', pauseAnimation, { passive: true });
    benefitsContainer.addEventListener('touchmove', pauseAnimation, { passive: true });
    benefitsContainer.addEventListener('touchend', resumeAnimation, { passive: true });
    benefitsContainer.addEventListener('touchcancel', resumeAnimation, { passive: true });

    // Mouse events (for testing on desktop/emulation)
    benefitsContainer.addEventListener('mousedown', pauseAnimation);
    benefitsContainer.addEventListener('mousemove', function(e) {
      if (e.buttons > 0) { // Only if mouse button is pressed
        pauseAnimation();
      }
    });
    benefitsContainer.addEventListener('mouseup', resumeAnimation);
    benefitsContainer.addEventListener('mouseleave', resumeAnimation);

    // Scroll events (manual scrolling)
    benefitsContainer.addEventListener('scroll', pauseAnimation, { passive: true });
    
    // Use IntersectionObserver to pause when not visible (performance optimization)
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting && !isInteracting) {
            track.classList.add('is-paused');
          } else if (entry.isIntersecting && !isInteracting) {
            track.classList.remove('is-paused');
          }
        });
      }, { threshold: 0 });

      observer.observe(benefitsContainer);
    }
  });
})();
